import { alertActions } from './AlertsActions'
import { usersLocalize } from '../../constants'
import { axiosPrivate } from '../../../axios'

export const CREATE_USER_INIT = 'CREATE_USER_INIT'
export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST'
export const CREATE_USER_SUCCESS = 'CREATE_USER'
export const CREATE_USER_ERROR = 'CREATE_USER'

export const createUser = (user) => (dispatch) => {
	const operationId = user.email
	dispatch({
		type: CREATE_USER_REQUEST,
		payload: {
			operationId
		}
	})
	axiosPrivate
		.post('/users', { ...user })
		.then((res) => {
			dispatch({
				type: CREATE_USER_SUCCESS,
				payload: {
					data: res.data,
					operationId
				}
			})
			dispatch(alertActions.successEnqueueSnackbar(usersLocalize.createdUserSuccessful(res.data.email)))
		})
		.catch((error) => {
			dispatch({
				type: CREATE_USER_ERROR,
				payload: {
					error,
					operationId
				}
			})
			dispatch(alertActions.errorEnqueueSnackbar(error?.message || usersLocalize.createdUserErr))
		})
}

export const initCreateUser = () => (dispatch) => {
	dispatch({ type: CREATE_USER_INIT })
}
